import Vue from 'vue'
import VueRouter from 'vue-router'
import Configurator from '../Configurator.vue'

Vue.use(VueRouter)


  const routes = [

    { 
      path: '/tank/:tankId', 
      name: 'tankId',
      component: Configurator
    }
    ,
    { 
      path: '/mode/:mode', 
      name: 'mode',
      component: Configurator
    }   

    /*
    {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/STERN webpackChunkName: "about" STERN/ '../views/About.vue')
  }
  /**/
]

const router = new VueRouter({
  //mode: 'history',
  routes
})

/*
router.map({
  '/tank/:slug': {
      component: Configurator,
      name: 'configurator'
  },
})
*/

export default router
